import { csvParse, tsvParse, autoType as typed } from "d3-dsv";
import { log, handleMissingKeys, arraysToData } from "../exports/helpers.js";
export default function parseDataFile(data, fileExtension, autoType = false, dataAsArrays = false, firstItem = 0, lastItem = Infinity, nbFirstRowsToExclude = 0, nbLastRowsToExclude = Infinity, fillMissingKeys = false, missingKeyValues = {
    null: null,
    NaN: NaN,
    undefined: undefined,
}, verbose = false) {
    verbose && log(`Parsing the data...`, "blue");
    let arrayOfObjects = [];
    if (typeof data === "string" &&
        (fileExtension === "csv" || fileExtension === "tsv")) {
        if (nbFirstRowsToExclude !== 0 || nbLastRowsToExclude !== Infinity) {
            const dataSplit = data.split("\n");
            data = dataSplit
                .slice(nbFirstRowsToExclude, dataSplit.length - nbLastRowsToExclude)
                .join("\n");
        }
        if (fileExtension === "csv") {
            arrayOfObjects = autoType
                ? csvParse(data, typed)
                : csvParse(data);
        }
        else if (fileExtension === "tsv") {
            arrayOfObjects = autoType
                ? tsvParse(data, typed)
                : tsvParse(data);
        }
        delete arrayOfObjects["columns"]; // weird
        arrayOfObjects = arrayOfObjects.slice(firstItem, lastItem + 1);
        const keys = Object.keys(arrayOfObjects[0]);
        const missingValueKeys = Object.keys(missingKeyValues);
        for (let i = 0; i < arrayOfObjects.length; i++) {
            for (let j = 0; j < keys.length; j++) {
                if (missingValueKeys.includes(arrayOfObjects[i][keys[j]])) {
                    const val = arrayOfObjects[i][keys[j]];
                    arrayOfObjects[i][keys[j]] = missingKeyValues[val];
                }
            }
        }
    }
    else if (fileExtension === "json" && typeof data === "string") {
        const incomingData = JSON.parse(data);
        arrayOfObjects = dataAsArrays
            ? arraysToData(incomingData, verbose)
            : incomingData;
        arrayOfObjects = arrayOfObjects.slice(firstItem, lastItem + 1);
    }
    else if (fileExtension === "json" && Array.isArray(data)) {
        arrayOfObjects = data.slice(firstItem, lastItem + 1);
    }
    else if (fileExtension === "json" && typeof data === "object") {
        arrayOfObjects = (dataAsArrays ? arraysToData(data, verbose) : data);
        arrayOfObjects = arrayOfObjects.slice(firstItem, lastItem + 1);
    }
    else {
        throw new Error("Unknown file extension " + fileExtension);
    }
    if (arrayOfObjects.length === 0) {
        throw new Error("Incoming data is empty.");
    }
    return handleMissingKeys(arrayOfObjects, fillMissingKeys, undefined, undefined, verbose);
}
//# sourceMappingURL=parseDataFile.js.map